// extracted by mini-css-extract-plugin
module.exports = {"accessBadges":"GymChainMembershipList_accessBadges__RY-Fp","accessBadge":"GymChainMembershipList_accessBadge__37hsL"};